module.exports = __webpack_public_path__ + "static/img/friend1.ce3eb3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/friend1.png
// module id = ctgN
// module chunks = 4